import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IDeleteQueueItem {
  uri: string | null;
  updatedUri: string | null;
  conceptUri: string | null;
  breadcrumbs: {
    domain: string | null;
    color: string | null;
    concept: string | null;
    property: string | null;
  };
  type: {
    action: string;
    resource: string;
  };
}

interface IDomainDependenciesDeleteQueueState {
  deleteQueue: IDeleteQueueItem[];
  activeDeleteItem: IDeleteQueueItem;
}

const defaultBreadcrumbs = { domain: null, color: null, concept: null, property: null };
const defaultType = {
  action: '',
  resource: '',
};
const defaultActiveDeleteItem = {
  uri: null,
  updatedUri: null,
  conceptUri: null,
  breadcrumbs: defaultBreadcrumbs,
  type: defaultType,
};

const initialState: IDomainDependenciesDeleteQueueState = {
  deleteQueue: [],
  activeDeleteItem: defaultActiveDeleteItem,
};

const domainDependenciesDeleteQueueSlice = createSlice({
  name: 'domainDependenciesDeleteQueue',
  initialState,
  reducers: {
    addToDeleteQueue: (state, action: PayloadAction<IDeleteQueueItem>) => {
      state.activeDeleteItem = action.payload;
      state.deleteQueue.push(action.payload);
    },
    removeFromDeleteQueue: (
      state,
      action: PayloadAction<Pick<IDeleteQueueItem, 'uri' | 'conceptUri'>>
    ) => {
      const { uri, conceptUri } = action.payload;
      state.deleteQueue = state.deleteQueue.filter(
        (item) => item.uri !== uri || item.conceptUri !== conceptUri
      );
      state.activeDeleteItem = defaultActiveDeleteItem;
    },
    clearDeleteQueue: (state) => {
      state.deleteQueue = [];
      state.activeDeleteItem = defaultActiveDeleteItem;
    },
  },
});

export const { addToDeleteQueue, removeFromDeleteQueue, clearDeleteQueue } =
  domainDependenciesDeleteQueueSlice.actions;

export default domainDependenciesDeleteQueueSlice.reducer;
